import { makeApiRequest } from 'actions/api';
import { GET_COMPLETED_REVIEWS_V3 } from 'lib/constants/v3Actions';
import RequestService from 'services/RequestService';

export const getCompletedReviews = () =>
  makeApiRequest({
    requestType: GET_COMPLETED_REVIEWS_V3,
    method: RequestService.v3.getCompletedReviews,
  });
